//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {windVane} from '../../../utils/tmallGenius'
import Hub from './hub.vue'

export default {
  components: {Hub,},
  data() {
    return {}
  },
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("添加智能主机");
    next();
  },
  /*------------------------------------------- 开始运行 -------------------------------------------------------*/
  created() {

  },
  methods: {
    /*------------------------------------------- 绑定函数 -------------------------------------------------------*/
    /*  回到首页点击
    * */
    goBackClick(){
      this.$router.go(-2);
    },
    /*  添加其他子设备点击
    * */
    addSubDeviceClick(){
      this.$router.replace('/connect/zigbee/scan')
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/connect/zigbee/Hub_listAdded.vue